import { render } from "./popup.vue?vue&type=template&id=529a06cc&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import "./popup.vue?vue&type=style&index=0&id=529a06cc&lang=css"
import "./popup.vue?vue&type=style&index=1&id=529a06cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529a06cc"],['__file',"src/components/popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "529a06cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('529a06cc', __exports__)) {
    api.reload('529a06cc', __exports__)
  }
  
  module.hot.accept("./popup.vue?vue&type=template&id=529a06cc&scoped=true", () => {
    api.rerender('529a06cc', render)
  })

}


export default __exports__